module.exports = __webpack_public_path__ + "static/buildingcups2-d447df15e46834d6234d99db8b2a12b2.jpeg";